/** Shared layoutIds for onboarding morph transitions (intent → details → ready). */
export const ONBOARDING_LAYOUT = {
  primarySurface: 'onboarding-primary-surface',
  workspaceName: 'onboarding-workspace-name',
} as const;

export const onboardingSpring = {
  type: 'spring' as const,
  stiffness: 380,
  damping: 34,
  mass: 0.85,
};

export const onboardingSoftSpring = {
  type: 'spring' as const,
  stiffness: 420,
  damping: 36,
};
